<template>
    <div class="modal modal--xs" id="buy-click">
        <div class="modal-form modal-form--left">
            <div class="modal-form__title">Купить в один клик </div>
            <div class="form-confirm">
                <form class="form" action=""  autocomplete="new-password">
                    <div class="form__inputs">
                        <div class="default-input">
                            <label class="default-input__label" for="">Ваше имя</label>
                            <div class="default-input__input"
                                 :class="{'default-input__input--error' : v$.formData.name.$errors.length}">
                                <input type="text" v-model="formData.name" inputmode="text" placeholder="Иван" name="name"/>
                            </div>
                            <div v-if="v$.formData.name?.$errors[0]" class="default-input__error">
                                {{ v$.formData.name?.$errors[0].$message }}
                            </div>
                        </div>
                        <div class="default-input">
                            <label class="default-input__label" for="">Введите ваш телефон</label>
                            <div class="default-input__input"
                                 :class="{'default-input__input--error' : v$.formData.phone.$errors.length}">
                                <input v-model="formData.phone" autocomplete="off"  type="tel" ref="inputPhone"
                                       placeholder="+7 (999) 999 99 99" inputmode="tel" name="phone">
                            </div>
                            <div v-if="v$.formData.phone?.$errors[0]" class="default-input__error">
                                {{ v$.formData.phone?.$errors[0].$message }}
                            </div>
                        </div>
                        <div class="form__code">
                            <InputCode
                                v-if="status === 'waitCodeEnter'"
                                :wait-timer="60"
                                :phone="formData.phone"
                                :error-text="v$.formData.code.$errors"
                                @setComplete="setCode"
                                @repeat="handleRequestCode"
                            />
                        </div>
                    </div>
                    <div class="form__submit">

                        <div class="form__submit-text">
                            <div class="default-checkbox">
                                <input hidden="" class="default-checkbox__input" id="checkbox-popup-buy-click-advert-agreement" type="checkbox" name="advert-agreement" value="Y" required />
                                <label class="default-checkbox__label" for="checkbox-popup-buy-click-advert-agreement">
                                    <span>Я&nbsp;<a :href="documents['advertising-agreement']" target="_blank" >согласен на получение рекламы</a></span>
                                </label>
                            </div>
                        </div>

                        <button class="form__submit-btn btn color" type="button" @click.prevent.stop="sendForm">Отправить</button>

                        <div class="form__submit-text">
                            <p>
                                Нажимая кнопку «Отправить», вы даете информированное
                                <a :href="documents['personal-data']" target="_blank">согласие на обработку персональных данных</a>
                                в соответствии с <a :href="documents['policy']" target="_blank">Политикой обработки персональных данных потребителей</a>
                            </p>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <teleport to=".popups">
            <PopupOrderingError v-if="showErrorModal" :errors="errors"/>
        </teleport>
    </div>
</template>


<script>
import useVuelidate from "@vuelidate/core";
import {required, helpers, maxLength} from '@vuelidate/validators'
import {reactive} from "vue";
import Inputmask from "inputmask";
import {mapActions, mapGetters, mapMutations} from "vuex";
import InputCode from "@/components/utils/InputCode.vue";
import {getOrdering} from "@/mixins/getOrdering";
import PopupOrderingError from "@/components/Cart/CartOrder/PopupOrderingError.vue";
import openFancybox from "@/utils/Fancybox";
import executeRecaptcha from "@/utils/ExecuteRecaptcha";


const {withMessage} = helpers

export default {
    name: "PopupBuyClick",
    mixins: [getOrdering],
    components: {PopupOrderingError, InputCode},
    setup() {
        const externalResults = reactive({});
        return {
            externalResults,
            v$: useVuelidate({$externalResults: externalResults})
        }
    },
    data() {
        return {
            loading: false,
            userDataTrigger: null,
            formData: {
                name: '',
                phone: '',
                code: '',
            },
            status: 'waitPhoneEnter',
            showErrorModal: false,
            errors: [],
        }
    },
    validations() {
        return {
            formData: {
                name: {
                    required: withMessage('Необходимо указать имя', required),
                    maxLength: withMessage('Максимальная длина поля 50 символов', maxLength(50)),
                },
                phone: {
                    required: withMessage('Необходимо указать телефон', required),
                },
                code: {
                    required: withMessage('Введите код подтверждения', this.validateCode),
                }
            }
        }
    },
    watch: {
        'formData.phone': function () {
            if (this.status !== 'waitPhoneEnter') this.status = 'waitPhoneEnter';
            this.v$.$clearExternalResults();
            this.formData.code = '';
        }
    },
    async mounted() {
        Inputmask('+7 (999) 999 99 99').mask(this.$refs.inputPhone)
        this.setInitialData()
    },
    computed: {
        ...mapGetters({
            userData: 'user/getUserData',
            documents: 'getDocuments',
            getCurrentItemId: "catalog/getCurrentItemId",
        })
    },
    methods: {
        setInitialData() {
			if (this.userData) {
				this.formData = {
					name: this.userData.name,
					phone: this.userData.phone
				}
			} else {
				this.formData = {
					name: '',
					phone: '',
                    code: ''
				}
				if (!this.userDataTrigger) {
					this.userDataTrigger = this.$watch('userData',  (newValue) => {
						this.formData = {
							name: newValue.name,
							phone: newValue.phone
						}
						this.userDataTrigger();
					});
				}
			}
		},       
        openErrorModal() {
            this.showErrorModal = true;
            this.$nextTick(() => {
                openFancybox('ordering-error');
            })
        },
        validateCode() {
          if (this.status === 'waitPhoneEnter') {
              return true
          }
          return this.formData.code.length === 4
        },
        setCode(code) {
            this.formData.code = code;
            this.handleCodeEnter();
        },
        handleRequestCode() {

        },
        handleCodeEnter() {
            this.v$.$reset();
            this.v$.$clearExternalResults();
            this.sendForm();
        },
        async sendForm() {
            const result = await this.v$.formData.$validate()
            if (!result) return

            const token = await executeRecaptcha()
            
            const data = {...this.formData};
            data.id = this.getCurrentItemId;
            data.token = token
            console.log(data)
            const res = await this.buyOneClick(data);

            if (res.data.order_link) window.location.href = res.data.order_link;

            else if (res.data?.status === 'sendCode' || res.data?.status === 'codeNotFound') {
                this.status = 'waitCodeEnter'
            }

            else {
                res.data.errors.forEach(item => {
                    try {
                        this.errors.push(`${JSON.parse(item).article} ${JSON.parse(item).message}`)
                    } catch {
                        this.errors = res.orderAll?.ERROR
                    }
                })
                this.openErrorModal();
            }

        },
        clearForm() {
            this.formData = {
                name: '',
                phone: '',
            }
            this.v$.$reset()
        },
        ...mapMutations({
            setCartStatus: 'catalog/setCartStatus'
        }),
        ...mapActions({
            buyOneClick: 'catalog/buyOneClick'
        })
    }
}
</script>
